import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import NewsSourcesPage from './pages/NewsSourcesPage';
import NewsCategoriesPage from './pages/NewsCategoriesPage';
import NewsArticlesPage from './pages/NewsArticlesPage';
import ForumRoomsPage from './pages/ForumRoomsPage';
import ForumTopicsPage from './pages/ForumTopicsPage';
import ForumPostsPage from './pages/ForumPostsPage';
import FireRiskPage from './pages/FireRiskPage';
import AdvertisersPage from './pages/AdvertisersPage';
import CampaignsPage from './pages/CampaignsPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import SuppliersPage from './pages/SuppliersPage';
import QuotesPage from './pages/QuotesPage';
import ForestryOperationsPage from './pages/ForestryOperationsPage';
import ProductPricingPage from './pages/ProductPricingPage';
import UsersPage from './pages/UsersPage';
import NotificationsPage from './pages/NotificationsPage';
import SettingsPage from './pages/SettingsPage';
import StatisticsPage from './pages/StatisticsPage';
import MapLayersPage from './pages/MapLayersPage';
import MapLayerEditPage from './pages/MapLayerEditPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/categories" element={<NewsCategoriesPage />} />
        <Route path="/rss-sources" element={<NewsSourcesPage />} />
        <Route path="/news" element={<NewsArticlesPage />} />
        <Route path="/forum-rooms" element={<ForumRoomsPage />} />
        <Route path="/forum-rooms/:roomId/topics" element={<ForumTopicsPage />} />
        <Route path="/forum-topics" element={<ForumTopicsPage />} />
        <Route path="/forum-topics/:topicId/posts" element={<ForumPostsPage />} />
        <Route path="/forum-posts" element={<ForumPostsPage />} />
        <Route path="/fire-risk" element={<FireRiskPage />} />
        <Route path="/advertisers" element={<AdvertisersPage />} />
        <Route path="/advertisers/:advertiserId/campaigns" element={<CampaignsPage />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/suppliers" element={<SuppliersPage />} />
        <Route path="/quotes" element={<QuotesPage />} />
        <Route path="/forestry-operations" element={<ForestryOperationsPage />} />
        <Route path="/product-pricing" element={<ProductPricingPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/settings/email-templates" element={<SettingsPage />} />
        <Route path="/settings/map-layers" element={<MapLayersPage />} />
        <Route path="/settings/map-layers/:layerId" element={<MapLayerEditPage />} />
        <Route path="/statistics" element={<StatisticsPage />} />
      </Route>
    </Routes>
  );
}
